import theme from './theme/id_ID';
import profile from './profile/id_ID';
import member from './member/id_ID';
import organization from './organization/id_ID';
import console from './console/id_ID';
import aws from './aws/id_ID';
import activity from './activity/id_ID';

export default {
  ...theme,
  ...profile,
  ...console,
  ...organization,
  ...member,
  ...aws,
  ...activity,
};
